import {AfterViewInit, Component, computed, HostListener, inject, signal} from '@angular/core';
import {Router} from '@angular/router';
import {Tab, TabsStore} from '../../state';

@Component({
    selector: 'app-tab-bar',
    templateUrl: './tab-bar.component.html',
    styleUrls: ['./tab-bar.component.scss'],
    standalone: false
})
export class TabBarComponent implements AfterViewInit {
  private tabsStore = inject(TabsStore);
  private router = inject(Router);

  readonly tabs = this.tabsStore.tabs;
  readonly activeTabIndex = this.tabsStore.activeTabIndex;
  readonly showTabs = this.tabsStore.hasTabs;

  readonly tabsOpen = signal(false);
  readonly screenWidth = signal('100%');

  readonly tabHeight = computed(() => {
    if (!this.showTabs() || !this.tabsOpen()) return 0;
    return this.tabs().length * 3;
  });

  ngAfterViewInit(): void {
    setTimeout(() => this.screenWidth.set(window.innerWidth + 'px'));
  }

  @HostListener('window:resize', ['$event'])
  onResize(_event: Event): void {
    setTimeout(() => this.screenWidth.set(window.innerWidth + 'px'));
  }

  isTabActive(tab: Tab): boolean {
    const tabPath = tab.route.match(/\d+/g);
    const urlPath = window.location.pathname.match(/\d+/g);
    return urlPath?.length > 0 && tabPath?.length > 0 && urlPath[0] === tabPath[0];
  }

  closeTab(event: MouseEvent, index: number): void {
    event.preventDefault();
    event.stopPropagation();
    this.tabsStore.closeTab(index);
  }

  activateTab(route: string): void {
    this.router.navigateByUrl(route);
  }

  toggleTabs(): void {
    this.tabsOpen.update(v => !v);
  }

  isCurrentTabActive(index: number): boolean {
    return index === this.activeTabIndex();
  }
}
